/** @format */

// Packages like pouchdb expect Node's `global` in the browser.
if (typeof globalThis !== 'undefined' && typeof globalThis.global === 'undefined') {
  globalThis.global = globalThis;
}
